
export default {
	formatNum(num) {
		num = parseFloat(num)

		// If it is a float, restrict to 2 decimals
		//num = num % 1 !== 0 ? num.toFixed(2) : num.toFixed(0)
		num = Math.round(num).toFixed(0)
		num = num.replace('.', ',')

		return ! num ? num : num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
	},

	num(num) {
		if (typeof num === 'string') {
			num = num.replace(',', '.')
		}

		return isNaN(parseFloat(num)) ? 0 : parseFloat(num)
	},

	__(strId) {
		return window.texts[strId] || ''
	},

	calculateTotalInc(article) {
		return this.num(article.quantity) * this.calculateInc(article) - this.num(article.discount)
	},
	calculateInc(article) {
		return this.num(article.out_price_ex_sek) * 1.25
	},

	isStandard(row) {
		if (row.category.category_nr == 14) {
			return true
		}

		return parseInt(row.article.out_price_ex_sek) === 0
	}
}
